require("-!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!style-loader!css-loader?sourceMap!cssnext-loader!../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./list.vue")
module.exports = require("-!../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./list.vue")
;(typeof module.exports === "function" ? module.exports.options : module.exports).template = require("-!vue-html!../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./list.vue")
if (module.hot) {
(function () {
var hotAPI = require("E:\\zhe_li_you_xuan\\hotelInfo\\node_modules\\vue-hot-reload-api\\index.js")
hotAPI.install(require("vue"))
if (!hotAPI.compatible) return
var id = "-!../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./list.vue"
hotAPI.createRecord(id, module.exports)
module.hot.accept(["-!../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./list.vue","-!vue-html!../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./list.vue"], function () {
var newOptions = require("-!../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./list.vue")
var newTemplate = require("-!vue-html!../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./list.vue")
hotAPI.update(id, newOptions, newTemplate)
})
})()
}


//////////////////
// WEBPACK FOOTER
// ./src/views/list.vue
// module id = 74
// module chunks = 0